import { validate as isUUID } from 'uuid'
import { Button } from '@/components/ui/button'

import { useShallow } from 'zustand/react/shallow'
import { useTechnicianPageStore } from '../hooks/useTechnicianPageStore'
import { useTechnicianDocument } from '../hooks/useTechnicianDocument'
import { useCreateSessionEvent } from '../hooks/useCreateSessionEvent'
import { findSubPageIndex } from '@/pages/TechnicianPage/fns'

export const PrevButton = ({ prevId }: { prevId?: string | null }) => {
  const setCurrentPage = useTechnicianPageStore(
    useShallow((state) => state.setCurrentPage),
  )
  const { createSessionEvent } = useCreateSessionEvent()
  const { currentPage } = useTechnicianDocument()

  return (
    <Button
      onClick={() => {
        const currentPageId = currentPage?.subPageId || currentPage?.id

        if (currentPage && currentPageId && isUUID(currentPageId)) {
          void createSessionEvent({
            documentPageId: currentPage.id,
            buttonLabel: 'Prev',
            subPageIndex: findSubPageIndex(currentPage),
          })
        }

        if (prevId) {
          setCurrentPage(prevId)
        }
      }}
      disabled={!prevId}
      size="lg"
      className="rounded-full"
      data-testid="technician-mode-prev-button"
    >
      Prev
    </Button>
  )
}
